module.exports = __webpack_public_path__ + "static/CustomerOne-cbda22a9d89d28ee99c7035eadaee061.jpeg";